import { FormControl, MenuItem, TextField } from "@mui/material";
import { SubscriptionStatus, VoipParams } from "../../../interfaces/Hoster";
import BaseModule, { BaseModuleProps } from "./baseModule";

interface VoipModuleProps extends Omit<BaseModuleProps, "name" | "label"> {}

export default function VoipModule(props: VoipModuleProps) {
  const {
    setHoster,
    hoster: { subscriptionStatus },
    hoster,
  } = props;

  const onChangeVoip = (key: string = "", value: string | number = "") => {
    const voip: VoipParams = hoster.subscriptionStatus
      ?.voipParams as VoipParams;
    const newVoipParams: VoipParams = {
      ...voip,
      [key]: value,
    };
    const newSubscriptionStatus: SubscriptionStatus = {
      ...(hoster.subscriptionStatus as SubscriptionStatus),
      voipParams: newVoipParams,
    };
    setHoster({
      ...hoster,
      subscriptionStatus: newSubscriptionStatus,
    });
  };

  return (
    <BaseModule {...props} name="isVOIPSubscribed" label="Téléphonie VOIP">
      <FormControl sx={{ flexDirection: "column", mt: 1 }}>
        <TextField
          label="VOIP Version"
          variant="outlined"
          select
          onChange={(e) => onChangeVoip("version", Number(e.target.value))}
          value={subscriptionStatus?.voipParams?.version || 1}
        >
          <MenuItem value={1}>V1 - 3CX</MenuItem>
          <MenuItem value={2}>V2 - Twilio Pro</MenuItem>
        </TextField>
        {hoster?.subscriptionStatus?.voipParams?.version === 1 && (
          <>
            <TextField
              label="Channel Url"
              variant="outlined"
              margin="normal"
              onChange={(e) => onChangeVoip("channelUrl", e.target.value)}
              value={subscriptionStatus?.voipParams?.channelUrl || ""}
            />
            <TextField
              label="partyId"
              variant="outlined"
              margin="normal"
              onChange={(e) => onChangeVoip("partyId", e.target.value)}
              value={subscriptionStatus?.voipParams?.partyId || ""}
            />
          </>
        )}
      </FormControl>
    </BaseModule>
  );
}
